import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AppContext } from "../../AppContext";
export default function useRetailPromotion(items, enabled) {
    const { posProfile, socket } = useContext(AppContext);
    const [result, setResult] = useState(null),
        [pending, setPending] = useState(false),
        [error, setError] = useState(false),
        [revision, setRevision] = useState(0);
    const payload = JSON.stringify(
        (items || []).map((r) => ({
            item_code: r.item?.item_code || r.item_code,
            qty: r.qty,
            rate: r.item?.standard_rate ?? r.item?.rate ?? r.rate,
        })),
    );
    useEffect(() => {
        if (!enabled) return;
        const refresh = () => setRevision((v) => v + 1);
        const timer = setInterval(refresh, 30000);
        socket?.on?.("retail_promotions_changed", refresh);
        window.addEventListener("focus", refresh);
        return () => {
            clearInterval(timer);
            socket?.off?.("retail_promotions_changed", refresh);
            window.removeEventListener("focus", refresh);
        };
    }, [enabled, socket]);
    useEffect(() => {
        let active = true;
        setResult(null);
        setError(false);
        if (!enabled || !posProfile?.name) {
            setPending(false);
            return;
        }
        setPending(true);
        const timer = setTimeout(async () => {
            try {
                const { data } = await axios.post(
                    "method/restaurant_management.retail_promotions.preview",
                    { pos_profile: posProfile.name, items: payload },
                );
                if (active) setResult(data.message);
            } catch {
                if (active) setError(true);
            } finally {
                if (active) setPending(false);
            }
        }, 200);
        return () => {
            active = false;
            clearTimeout(timer);
        };
    }, [payload, posProfile?.name, enabled, revision]);
    return { result, pending, error };
}
